import type { Statistics } from "../../services/adminService";

/** Aligns with backend /statistics/ aggregates (e.g. master_folder filters). List API `count` can differ. */
export type StatisticContentKind =
  | "books"
  | "articles"
  | "audio"
  | "manuscripts"
  | "magazines"
  | "agam";

/**
 * When there are no filters that statistics cannot represent (language, search, etc.),
 * use the same totals as GET /statistics/. Otherwise keep the list API count.
 */
export function getPreviewCountMatchingStatistics(
  kind: StatisticContentKind,
  statistics: Statistics | null,
  apiCount: number,
  hasFiltersThatBreakStatistics: boolean
): number {
  if (!statistics || hasFiltersThatBreakStatistics) {
    return apiCount;
  }
  switch (kind) {
    case "books":
      return statistics.total_books ?? apiCount;
    case "articles":
      return statistics.total_articles ?? apiCount;
    case "audio":
      return statistics.total_audio ?? apiCount;
    case "manuscripts":
      return statistics.total_manuscripts ?? apiCount;
    case "magazines":
      return statistics.total_magazines ?? apiCount;
    case "agam":
      return statistics.total_agam ?? apiCount;
    default:
      return apiCount;
  }
}
